const lang = {
  contact: 'Kontakt',
  experience: 'Doświadczenie',
  education: 'Wykształcenie',
  skills: 'Umiejętności',
  about: 'O mnie'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/pl.js